/*
===============================================================================================================
                                 Copyright 2023-2023, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

const getImageDimensionsFromFile = (file) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => resolve({ width: img.width, height: img.height });
  img.src = URL.createObjectURL(file);
});

export default getImageDimensionsFromFile;
